import { StreamingApi } from '@img-arena/consoles-api-streaming'
import { DGE_AUTH_METHOD } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'

import { logoutOnUnauthorized } from './interceptors/logoutOnUnauthorized'

export const streamingRestApi = new StreamingApi(
  {
    baseURL: import.meta.env.VITE_ARGONATH_API,
    apiVersion: 'v1',
    getToken: () => useAuthStore.getState().token,
    getAuthMethod: () =>
      useAuthStore.getState().dgeAuthMethod === DGE_AUTH_METHOD.KEYCLOAK
        ? 'bearer'
        : 'exchange-auth'
  },
  {
    ...logoutOnUnauthorized,
    request: (request) => {
      if (!('params' in request && request.params && 'page' in request.params)) {
        return request
      }

      // streaming api uses 1-based index where we use 0-based index in the app
      request.params.page = request.params.page + 1

      return request
    },
    response: (response) => {
      if (
        !(
          typeof response.data === 'object' &&
          'number' in response.data &&
          response.config &&
          'params' in response.config &&
          response.config.params &&
          'page' in response.config.params
        )
      ) {
        return response
      }

      // streaming api uses 1-based index where we use 0-based index in the app
      response.data.number = response.data.number - 1

      return response
    }
  }
)
